require('./progression.less');

class ProgressionController {
    cards;
    progression;

    constructor(private PickStatus, private $filter, private toastService){
    }

    $onInit(){
        this.getPickStatus();
    }

    getPickStatus() {
        let date = new Date();
        this.PickStatus.getPickStatusTotal({date: this.$filter('date')(date, 'yyyy-MM-dd')}).$promise.then((total) => {
            if((!total.lineCount && total.lineCount !== 0) || (!total.pickedCount && total.pickedCount !== 0)){
                total = {lineCount: 0, pickedCount: 0};
            }
            this.cards = [
                {title: "Totalt", value: total.lineCount},
                {title: "Plukket", value: total.pickedCount},
                {title: "Gjenstående", value: total.lineCount - total.pickedCount}
            ];
            if(total.pickedCount <= 0) {
                this.progression = 0;
            }else {
                this.progression = (total.pickedCount/total.lineCount) * 100;
            }
        }, (error) => {
            this.toastService.parseError(error);
        })
    }

}

class ProgressionOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcProgressionController";
    public template: any = require('./progression.html');

}

rkcApp.controller("rkcProgressionController", ['PickStatus', '$filter', 'toastService',
    function(PickStatus, $filter, toastService){
        return new ProgressionController(PickStatus, $filter, toastService);
    }])
    .component("rkcProgression", new ProgressionOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/distribution/progression/progression.ts
 **/